// extracted by mini-css-extract-plugin
module.exports = {"content":"Qg","lookName":"Rg","shopTheLookContainer":"Sg","productContainer":"Tg","imageContainer":"Ug","mainImage":"Vg"};